<template>
  <div
    v-if="accountManager"
    class="account-manager am"
    :class="{ 'border-account-manager': displayTitle }"
  >
    <div class="am__body am-body">
      <div class="am-body__top am-body-top">
        <div class="am-body-top__left">
          <ProfilePicture :url="accountManager.picture_url" :user-firstname="accountManager.firstname" />
        </div>
        <div class="am-body-top__right am-body-top-right">
          <div v-if="displayTitle" class="am-body-top-right__title">
            {{
              trans('account_manager.title', {
                company_name: $companyName,
              })
            }}
          </div>
          <div class="am-body-top-right__name">
            {{ accountManager.firstname }}
            {{ accountManager.lastname }}
          </div>
          <div class="am-body-top-right__role">
            {{ trans('messaging.account_manager.role', { company_name: $companyName }) }}
          </div>
        </div>
      </div>
      <div
        v-if="accountManager.phone_number"
        class="am-body__phone"
      >
        <a :href="'tel:' + accountManager.phone_number">
          <span>{{ accountManagerPhone }}</span>
        </a>
      </div>
      <div class="am-body__email">
        <a :href="'mailto:' + accountManager.email">
          <span>{{ accountManager.email }}</span>
        </a>
      </div>
      <div
        v-if="accountManager.calendly_url"
        class="am-body__calendly"
      >
        <a target="_blank" :href="accountManager.calendly_url">
          <span>
            {{ trans('account_manager.make_an_appointment') }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { PhoneNumber } from '@tools/phoneNumber';
import ProfilePicture from '@components/ProfilePicture.vue';
import { translationMixin } from '@tools/translation';

export default {
  components: { ProfilePicture },
  mixins: [ translationMixin ],
  props: {
    accountManager: {
      type: Object,
      default: () => {},
    },
    displayTitle: { type: Boolean, default: true },
  },
  computed: {
    accountManagerPhone() {
      return this.accountManager.phone_number ? new PhoneNumber(this.accountManager.phone_number).printFormattedInternational : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@styles/variables/colors' as *;
@use '@styles/mixins/rem' as *;

@use '@styles/components/account-manager';

.border-account-manager {
  border: 1px solid $colorGray;
  border-radius: toRem(4);
  padding: toRem(16);
}
</style>
